import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import { setSnackbarListener } from '../../utils/snackbar';
import './AppSnackbar.css';

const AUTO_HIDE_MS = 5000;

const styles = {
  success: {
    backgroundColor: '#2e7d32',
  },
  error: {
    backgroundColor: '#d32f2f',
  },
  warning: {
    backgroundColor: '#ed6c02',
  },
  info: {
    backgroundColor: '#635ee7',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.95rem',
    lineHeight: 1.4,
  },
  close: {
    padding: 4,
    color: '#fff',
  },
};

// Global Material-UI v4 Snackbar toaster (no package upgrade)
class AppSnackbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      message: '',
      severity: 'info',
    };
  }

  componentDidMount() {
    setSnackbarListener(this.handleIncoming);
  }

  componentWillUnmount() {
    setSnackbarListener(null);
  }

  // Receive toast requests from showSnackbar helpers
  handleIncoming = (payload) => {
    this.setState({
      open: true,
      message: payload.message || '',
      severity: payload.severity || 'info',
    });
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    const { open, message, severity } = this.state;
    const bgClass = classes[severity] || classes.info;

    return (
      <Snackbar
        className="app-snackbar"
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        autoHideDuration={AUTO_HIDE_MS}
        onClose={this.handleClose}
      >
        <SnackbarContent
          className={bgClass}
          message={<span className={classes.message}>{message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>,
          ]}
        />
      </Snackbar>
    );
  }
}

export default withStyles(styles)(AppSnackbar);
